import { Box, Divider, Typography } from "@mui/material";
import { Map } from "ol";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDateFormatter } from "~/utils/hooks/useDateFormatter";
import { NauticalWarningMapItem } from "../types/mapItems";
import { GenericPopup } from "./GenericPopup";

type Props = {
  map: Map;
} & (ClickProps | HoverProps);

type ClickProps = {
  clickData: NauticalWarningMapItem;
  hoverData?: NauticalWarningMapItem;
};

type HoverProps = {
  hoverData: NauticalWarningMapItem;
  clickData?: NauticalWarningMapItem;
};

export const NauticalWarningPopup = ({
  hoverData,
  clickData,
  map,
}: Props): JSX.Element | null => {
  const { t } = useTranslation("nautical-warning");
  const dateFormatter = useDateFormatter();

  const data = clickData ?? hoverData;

  if (!data) return null;

  const {
    nauticalWarningId,
    locationFi,
    areasFi,
    contentsFi,
    publishingTime,
    notificator,
  } = data;

  return (
    <GenericPopup
      map={map}
      clicked={!!clickData}
      avatarText={nauticalWarningId?.toString() ?? ""}
      title={areasFi ?? ""}
      subheader={locationFi ?? ""}
      content={
        <Box>
          <Typography variant="body1">{`${t("publishing-time")}: ${
            publishingTime ? dateFormatter({ date: publishingTime }) : "-"
          }`}</Typography>
          {publishingTime ? <Divider /> : null}
          <Typography variant="body1">{`${t(
            "notificator",
          )}: ${notificator}`}</Typography>
          {publishingTime ? <Divider /> : null}
          <Typography variant="body2" align="left">
            {contentsFi}
          </Typography>
          {publishingTime ? <Divider /> : null}
        </Box>
      }
    />
  );
};
